import axios from "axios";
import { PAGE_LENGTH, qnaStateTypes } from "./constants";
import { Base64 } from "js-base64";
const { configURL } = JSON.parse(sessionStorage.getItem("config"));
const url = Base64.decode(configURL);
axios.defaults.baseURL = url;

const CHANNEL = "mobile";

//new
export const getChatRooms = () => {
  return axios.get("/QNACUSTOMER/api/v1/chat/get-chat-rooms");
};

export const getChatHistory = (chat_room_name, page) => {
  const chatsCount = PAGE_LENGTH;
  return axios({
    method: "get",
    url: "/QNACUSTOMER/api/v1/chat/get-chat-history",
    params: {
      chat_room_name,
      limit: chatsCount,
      skip: (page - 1) * chatsCount,
    },
  });
};
export const getHistory = (chat_room_name, page) => {
  const chatsCount = PAGE_LENGTH;
  return axios({
    method: "get",
    url: "/QNACUSTOMER/api/v1/livechat/customer/get-history",
    params: {
      chat_room_name,
      limit: chatsCount,
      skip: (page - 1) * chatsCount,
      // username: '9126505468'
    },
  });
};


export const askQuestion = (
  question,
  label_question = "",
  chat_room_name = ""
) => {
  return axios({
    method: "post",
    url: "/QNACUSTOMER/api/v1/chat/ask-question",
    data: {
      question,
      label_question,
      chat_room_name,
    },
    timeout: chat_room_name === "PLANNING_KB" ? 1000 * 60 : 1000 * 10
  });
};
export const askQuestionLV = (
  question,
  label_question = "",
  chat_room_name = ""
) => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  setTimeout(() => {
    source.cancel();
  }, 10000);
  return axios({
    method: "post",
    url: "/QNACUSTOMER/api/v1/livechat/customer/ask-question",
    data: {
      question,
      label_question,
      room_id: chat_room_name,
    },
    cancelToken: source.token,
  });
};
export const requestOtp = (cellnum) => {
  return axiosInstance({
    method: "get",
    url: "/AUTHACL/api/v1/otp/request-otp",
    params: {
      cellnum,
    },
  });
  // status,message,code
};

export const register = (formData) => {
  const { firstname, lastname, password } = formData;
  return axios({
    method: "post",
    url: "/QNACUSTOMER/api/v1/register",
    data: {
      firstname,
      lastname,
      password,
    },
  });
  // status,message,code
};
export const resetPassword = (password_new) => {
  return axios({
    method: "post",
    url: "/AUTHACL/api/v1/auth/user/reset-password",
    data: {
      password_new,
    },
  });
  // status,message,code
};
let axiosInstance = axios.create({
  baseURL: url,
});
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // throw error;
    switch (error?.response?.status) {
      case 401:
        return Promise.reject("خطای احراز هویت");
      case 404:
        return Promise.reject("درخواست یافت نشد");
      default:
        return Promise.reject("خطا در برقراری ارتباط");
    }
  }
);
export const checkToken = (token) => {
  return axiosInstance({
    method: "get",
    url: "/QNACUSTOMER/api/v1/check-token",
    headers: {
      Authorization: `Bearer ${token}`,
      channel: CHANNEL,
    },
    params: {
      // token,
    },
  });
  // status,message,code
};

export const asrDecode = (file) => {
  return axios.post("/QNACUSTOMER/api/v1/asr/decode", file);
};

export const getLastUsers = ({ chat_room_name }) => {
  return axios({
    method: "get",
    url: "/QNACUSTOMER/api/v1/admin/get-last-users",
    params: {
      chat_room_name,
    },
  });
  // status,message,code,cellnum,isregister
};

export const getIsUserAdmin = () => {
  return axios({
    method: "get",
    url: "/QNACUSTOMER/api/v1/admin/is-user-admin",
  });
  // status,message,code,cellnum,isregister
};
export const getOthersChats = ({ chat_room_name, target_username, page }) => {
  const chatsCount = PAGE_LENGTH;
  return axios({
    method: "get",
    url: "/QNACUSTOMER/api/v1/admin/get-another-user-history",
    params: {
      chat_room_name,
      target_username,
      limit: chatsCount,
      skip: (page - 1) * chatsCount,
    },
  });
  // status,message,code,cellnum,isregister
};

// jwt
export const userLogin = (username, password) => {
  return axiosInstance({
    method: "post",
    url: "/AUTHACL/api/v1/user/login",
    data: {
      username,
      password,
    },
  });
  // status,message,code,cellnum,isregister
};

export const userLoginByOtp = (cellnum, otp) => {
  return axiosInstance({
    method: "get",
    url: "/AUTHACL/api/v1/user/login-by-otp",
    params: {
      cellnum,
      otp,
    },
  });
  // status,message,code,cellnum,isregister
};

export const userResetPassword = (password_new) => {
  return axios({
    method: "post",
    url: "/AUTHACL/api/v1/user/reset-password",
    data: {
      password_new,
    },
  });
  // status,message,code
};
export const userRefresh = () => {
  const user = JSON.parse(localStorage.getItem("userinfo"));
  return axiosInstance({
    method: "post",
    url: "/AUTHACL/api/v1/user/refresh",
    headers: {
      Authorization: `Bearer ${user?.refreshToken}`,
    },
  });
  // status,message,code
};
export const sessionInit = () => {
  const user = JSON.parse(localStorage.getItem("userinfo"));
  return axiosInstance({
    method: "post",
    url: "/AUTHACL/api/v1/session/init",
    headers: {
      Authorization: `Bearer ${user?.refreshToken}`,
    },
  });
  // status,message,code
};


// live chat
export const getStateAndAnswer = ({ room_id }) => {
  return axios({
    method: "get",
    url: "/QNACUSTOMER/api/v1/livechat/customer/get-state-and-answer",
    params: {
      room_id
    }
  });
  // status,message,code,cellnum,isregister
};
export const postCustomerSetState = ({
  state,
  customer_id,
  room_id
}) => {
  return axios({
    method: "post",
    url: "/QNACUSTOMER/api/v1/livechat/customer/set-state",
    params: {
      state,
      customer_id,
      room_id
    },
  });
  // status,message,code,cellnum,isregister
};